<template>
	<div class="variant" :class="{active: cartItem}">
		<div class="cells">
			<div class="cell-title" v-text="description"/>
			<div class="cell-sku" v-text="sku"/>
			<div class="cell-price" v-text="price"/>
			<div class="cell-counter">
				<counter v-bind="{props: {rules, productId: product_id, variantId: id}}"/>
			</div>
		</div>
	</div>
</template>

<script>
import counter from "@/components/counter/full.vue";

export default {
	components: {counter},
	props: {
		description: {type: String, required: true},
		product_id: {type: Number, required: true},
		rules: {type: Object, required: true},
		price: {type: Number, required: true},
		sku: {type: String, required: true},
		id: {type: Number, required: true}
	},
	computed: {
		cartProduct: (t) => t.$store.getters["cart/products"].find(x => x.id === t.product_id),
		cartItem: (t) => t.cartProduct ? t.cartProduct.line_items.find(x => x.variant_id === t.id) : null
	}
};
</script>

<style  lang="scss" scoped>
.variant {
	margin-bottom: 1px;
	position: relative;
	background-color: #f9fafb;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
	font-weight: 300;

	&.active {
		font-weight: 500;
	}
}
</style>
